import { Group, MultiFormSelectOptions } from '@stylehaven/components';

export function GroupsToFormSelectOptions(groups: Group[]): MultiFormSelectOptions {
    return {
        options: groups.map(group => {
            return { label: group.Name, value: group.Id };
        }),
        isLiveData: false
    } as MultiFormSelectOptions;
}
